/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/jsx-no-undef */
import { FC, ReactNode } from 'react';

import { IconType } from 'react-icons';

import Link from 'next/link';

import { TColorProp, useTheme } from 'styled-components';

import { getThemeColor } from '~/common/utils/get-theme-color';
import { useCustomTheme } from '~/common/providers/theme';
import { ThemeOptionEnum } from '~/common/enum/theme-option-enum';

import { CustomArrow, Option } from './styles';
import { Typography } from '../Typography';

interface IGenericMenuItemProps {
  index: number;
  id?: string;
  selected: boolean;
  icon?: IconType;
  imageUrl?: string;
  withoutClick?: boolean;
  title: string;
  href?: string;
  hoverColor?: TColorProp;
  hoverColorOpacity?: number;
  customIcon?: ReactNode;
  transparentBackground?: boolean;
  iconColor?: TColorProp;
  iconHoverColor?: TColorProp;
  withoutIconHighligh?: boolean;
  backgroundColor?: TColorProp;
  currentOpacity?: number;
  currentColor?: TColorProp;
  paddingLeft?: string;
  currentIconColor?: TColorProp;
  arrowState?: 'top' | 'bottom';
  as?: string;
  compact?: boolean;
  allowTitleWrap?: boolean;
  onClick?: () => void;
}
export const GenericMenuItem: FC<IGenericMenuItemProps> = ({
  index,
  id,
  selected,
  icon: Icon,
  title,
  href,
  arrowState,
  paddingLeft,
  as = 'li',
  customIcon = null,
  currentOpacity = 0,
  hoverColorOpacity = 0,
  hoverColor = 'neutral.900',
  currentColor = 'neutral.900',
  backgroundColor = 'neutral.950',
  iconColor = 'neutral.500',
  currentIconColor = 'primary',
  iconHoverColor = iconColor,
  transparentBackground = false,
  withoutClick = false,
  withoutIconHighligh = false,
  compact = false,
  allowTitleWrap = false,
  imageUrl,
  onClick,
}) => {
  const { themeOption } = useCustomTheme();
  const theme = useTheme();

  const Element = (
    <Option
      withoutClick={withoutClick}
      id={id}
      hoverColor={hoverColor}
      as={as}
      paddingLeft={paddingLeft}
      key={String(index)}
      currentColor={currentColor}
      currentOpacity={currentOpacity}
      hoverColorOpacity={hoverColorOpacity}
      current={selected}
      onClick={onClick}
      transparentBackground={transparentBackground}
      iconHoverColor={iconHoverColor}
      backgroundColor={backgroundColor}
      $allowTitleWrap={allowTitleWrap}
    >
      {Icon && (
        <Icon
          size={20}
          color={
            selected && !withoutIconHighligh
              ? getThemeColor(theme, currentIconColor)
              : getThemeColor(theme, iconColor)
          }
        />
      )}

      {customIcon && customIcon}

      {imageUrl && (
        <img
          src={imageUrl}
          alt={title}
          style={{
            width: '20px',
            height: '20px',
            borderRadius: '50%',
          }}
        />
      )}

      {!compact && (
        <>
          <Typography.Label
            size="medium"
            color={
              themeOption === ThemeOptionEnum.light
                ? 'neutral.500'
                : 'neutral.200'
            }
          >
            {title}
          </Typography.Label>

          {arrowState && (
            <div style={{ marginLeft: 'auto' }}>
              <CustomArrow
                to={arrowState}
                color={theme.neutral[400]}
                size={26}
              />
            </div>
          )}
        </>
      )}
    </Option>
  );

  return href ? (
    <Link href={href} passHref>
      {Element}
    </Link>
  ) : (
    Element
  );
};
